import { render, staticRenderFns } from "./Form32LinkExternal.vue?vue&type=template&id=640e5ba5&scoped=true&"
import script from "./Form32LinkExternal.vue?vue&type=script&lang=js&"
export * from "./Form32LinkExternal.vue?vue&type=script&lang=js&"
import style0 from "./Form32LinkExternal.vue?vue&type=style&index=0&id=640e5ba5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640e5ba5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VFlex,VLayout})
